import { render, staticRenderFns } from "./authorizeDomain.vue?vue&type=template&id=db904ae6&"
import script from "./authorizeDomain.vue?vue&type=script&lang=ts&"
export * from "./authorizeDomain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports